import { render, staticRenderFns } from "./public-ebooks-list.vue?vue&type=template&id=41bc35ec&"
import script from "./public-ebooks-list.vue?vue&type=script&lang=js&"
export * from "./public-ebooks-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports